
require('inputmask');
require('inputmask/lib/jquery.inputmask');
require('inputmask/lib/extensions/inputmask.extensions');
require('inputmask/lib/extensions/inputmask.date.extensions');
require('inputmask/lib/extensions/inputmask.numeric.extensions');
require('inputmask/lib/bindings/inputmask.binding');

Inputmask.extendAliases({
    'moneyBrl': {
        alias: 'decimal',
        autoUnmask: true,
        prefix: 'R$ ',
        radixPoint: ',',
        groupSeparator: '.',
        digits: 2,
        digitsOptional: false,
        placeholder: '0',
        numericInput: true,
        onBeforeMask: function (value, opts) { },
    },
    'phoneBr': {
        mask: ['(99) 9999-9999', '(99) 99999-9999'],
        greedy: false,
    }
});
